import { z } from 'zod';

export const CREATE_ENTITY_RECORD_TARGET_TYPES = ['Risk', 'Ticket', 'Asset'];

const VARIABLE_KEY_RE = /^[a-zA-Z_][a-zA-Z0-9_]{0,63}$/;
const IDEMPOTENCY_KEY_RE = /^[a-zA-Z0-9_-]+$/;

/**
 * `ACTION` node `actionConfig` when `actionType === 'create-entity-record'`.
 * `mapping` values are validated at runtime by the API resolver (modes: static / fromSource / jsonata).
 */
export const workflowCreateEntityRecordActionConfigSchema = z
    .object({
        targetEntityType: z.enum(CREATE_ENTITY_RECORD_TARGET_TYPES),
        mapping: z.record(z.string(), z.any()).default({}),
        outputVariableKeys: z.array(z.string()).optional(),
        idempotencyKey: z.string().max(64).optional(),
    })
    .passthrough()
    .superRefine((val, ctx) => {
        if (val.idempotencyKey != null && val.idempotencyKey !== '') {
            if (!IDEMPOTENCY_KEY_RE.test(String(val.idempotencyKey))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['idempotencyKey'],
                    message: 'idempotencyKey yalnızca harf, rakam, _ ve - içerebilir',
                });
            }
        }
        const keys = val.outputVariableKeys;
        if (!Array.isArray(keys)) return;
        keys.forEach((k, i) => {
            if (typeof k !== 'string' || !VARIABLE_KEY_RE.test(k)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['outputVariableKeys', i],
                    message: 'Geçersiz değişken anahtarı',
                });
            }
        });
    });

/**
 * @param {unknown} input - `actionConfig` slice (not full node.config).
 */
export function safeParseCreateEntityRecordActionConfig(input) {
    const raw = input && typeof input === 'object' ? input : {};
    const withDefaults = {
        ...raw,
        mapping:
            raw.mapping && typeof raw.mapping === 'object' && !Array.isArray(raw.mapping)
                ? raw.mapping
                : {},
    };
    const parsed = workflowCreateEntityRecordActionConfigSchema.safeParse(withDefaults);
    if (parsed.success && parsed.data.idempotencyKey === '') {
        return {
            ...parsed,
            data: { ...parsed.data, idempotencyKey: undefined },
        };
    }
    return parsed;
}
